export default "/images/scouts_icon.svg"